import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { getDetail } from './addOnPageUtils';
import { getMenusByTemplate } from '../../../../../ui-kitchen/src/api/api';
import { ISO_DATE_FORMAT } from '../../../../../ui-kitchen/src/constants/resyCore';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

// useDetailForAddOnState Custom Hook
//
// Listens for updates to related data, and updates addons state accordingly.
// Returns detailForAddons and menu used for addons route
const useDetailForAddOnState = ({
  bookingState,
  selectedDate,
  templateId,
  templates,
  venue,
}) => {
  const [detailForAddons, setDetailForAddons] = useState(null);
  const [menu, setMenu] = useState(null);
  useEffect(() => {
    if (isEmpty(venue) || !templateId || !bookingState?.reservation) {
      return;
    }
    if (templateId) {
      const detail = getDetail({
        seats: bookingState?.partySize,
        venueName: venue.name,
        city: venue.location?.city,
        reservation: bookingState?.reservation,
        currencyCode: venue.locale?.currency,
        templates,
      });
      setDetailForAddons(detail);
      getMenusByTemplate(venue.id, templateId, {
        date: moment(selectedDate).format(ISO_DATE_FORMAT),
      })
        .then((response) => {
          const menuData = response[0];
          setMenu(menuData);
        })
        .catch((error) => Logger.error('[WIDGET VENUE PAGE] error getting menus by template: ', error));
    }
  }, [templateId, bookingState?.reservation, selectedDate, venue]);
  return { detailForAddons, menu };
};

export default useDetailForAddOnState;
